import PropTypes from 'prop-types';
import React from 'react';
import { ConsentTypeChoice, Button, InputField } from '@unite-us/app-components';
// import { Button, InputField } from '@unite-us/ui';
import { validateEmailAddress, validatePhoneNumber } from 'src/components/InformedConsent/utils/validations';
import { CONSENT_OPTIONS } from 'src/components/InformedConsent/constants';

const DigitalConsentSection = ({
  fields,
  registerField,
  onSubmit,
  selectConsentType,
  selectedConsentType,
  showConsent,
}) => (
  <div className="consent-type-choices-group">
    <h3 className="consent-type-choices-group__title">
      Digital Consent
    </h3>
    <div className="flex flex-col gap-2">
      <ConsentTypeChoice
        type={CONSENT_OPTIONS.PHONE_NUMBER}
        label="Send request for signature by text message (SMS)"
        onSelect={selectConsentType}
        selectedType={selectedConsentType}
      >
        <div className="flex items-start gap-x-8 gap-y-4 flex-wrap">
          <div className="flex-auto" style={{ flexGrow: 2 }}>
            <InputField
              ref={registerField}
              id="phone-number"
              label="Phone Number"
              field={fields[CONSENT_OPTIONS.PHONE_NUMBER]}
              hideLabel
              disabled={selectedConsentType !== CONSENT_OPTIONS.PHONE_NUMBER}
              mask="(999) 999-9999"
              validations={{ func: validatePhoneNumber }}
              style={{ input: { margin: '0' } }}
            />
          </div>
          <div className="flex-1 flex-shrink-0">
            <Button
              id="consent-submit-phone-btn"
              className="consent-submit-request-by-phone-btn h-9 whitespace-nowrap"
              label="Submit"
              onClick={onSubmit}
              primary
            />
          </div>
        </div>
      </ConsentTypeChoice>

      <ConsentTypeChoice
        type={CONSENT_OPTIONS.EMAIL_ADDRESS}
        label="Send request for signature by Email"
        onSelect={selectConsentType}
        selectedType={selectedConsentType}
      >
        <div className="flex items-start gap-x-8 gap-y-4 flex-wrap">
          <div className="flex-auto" style={{ flexGrow: 2 }}>
            <InputField
              ref={registerField}
              id="email-address"
              label="Email Address"
              field={fields[CONSENT_OPTIONS.EMAIL_ADDRESS]}
              hideLabel
              disabled={selectedConsentType !== CONSENT_OPTIONS.EMAIL_ADDRESS}
              validations={{ func: validateEmailAddress }}
              style={{ input: { margin: '0' } }}
            />
          </div>
          <div className="flex-1 flex-shrink-0">
            <Button
              id="consent-submit-email-btn"
              className="consent-submit-request-by-email-btn"
              label="Submit"
              onClick={onSubmit}
              primary
            />
          </div>
        </div>
      </ConsentTypeChoice>

      <ConsentTypeChoice
        type={CONSENT_OPTIONS.ON_SCREEN}
        label="On-Screen Consent"
        onSelect={selectConsentType}
        selectedType={selectedConsentType}
      >
        <Button
          id="go-to-form-btn"
          className="consent-go-to-form-btn h-9 whitespace-nowrap"
          label="Go To Form"
          primary
          onClick={showConsent}
        />
      </ConsentTypeChoice>
    </div>
  </div>
);

DigitalConsentSection.propTypes = {
  fields: PropTypes.object.isRequired,
  registerField: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  selectConsentType: PropTypes.func.isRequired,
  selectedConsentType: PropTypes.string.isRequired,
  showConsent: PropTypes.func.isRequired,
};

export default DigitalConsentSection;
